import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Time16 } from '@carbon/icons-react';
import SearchItem from './searchItem';
import {
  MapSearchLocationHistoryObject,
  MAP_DATA_SERVICE_DATA_SET
} from 'types';
import { optimizeLabel } from './helper';

const ResultsBox: React.FC<Props> = (props) => {
  const { userSearchHistory, items, onItemClick } = props;
  const [searchHistory, setSearchHistory] = useState<
    MapSearchLocationHistoryObject[]
  >([]);

  useEffect(() => {
    const filteredSearchHistory = userSearchHistory.filter(
      (sh: any) => sh.scope === MAP_DATA_SERVICE_DATA_SET.GNAF
    );
    setSearchHistory(filteredSearchHistory);
  }, [userSearchHistory]);

  return (
    <>
      {items.map((item: any, inx: number) => {
        return (
          <SearchItem
            key={inx}
            customClassName={`${
              inx === items.length - 1 ? 'mls-suggestion-last-item' : ''
            }`}
            label={optimizeLabel(
              item.Value,
              item.CustomFields,
              !!item.MagicKey
            )}
            item={item}
            onItemClick={onItemClick}
          />
        );
      })}
      {/* <SearchItem
        customClassName="mls-c-location"
        label="Use my current location"
        onItemClick={onClickCurrentLocation}
        icon={<SendAlt16 />}
      /> */}
      {searchHistory.length > 0 && (
        <SearchItem
          customClassName="mls-c-title"
          label="RECENTS"
          clickable={false}
          icon={<Time16 />}
        />
      )}
      {searchHistory.map((sh: any, inx: number) => {
        return (
          <SearchItem
            key={inx}
            label={optimizeLabel(
              sh.Value,
              sh.CustomFields,
              !!sh.Extent,
              !!sh.Extent
            )}
            item={sh}
            onItemClick={onItemClick}
          />
        );
      })}
    </>
  );
};

const propTypes = {
  userSearchHistory: PropTypes.array.isRequired,
  items: PropTypes.any,
  onItemClick: PropTypes.func,
  onClickCurrentLocation: PropTypes.func
};

type Props = PropTypes.InferProps<typeof propTypes>;

ResultsBox.defaultProps = {
  userSearchHistory: [],
  items: [],
  onItemClick: () => {},
  onClickCurrentLocation: () => {}
};

export default ResultsBox;
